var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiAssistant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.19 47.57H10.25a3.15 3.15 0 0 1-3.15-3.15V30.21a3.15 3.15 0 0 1 3.15-3.15h21.94a3.15 3.15 0 0 1 3.14 3.15v14.21a3.15 3.15 0 0 1-3.14 3.15zM10.25 29.06a1.14 1.14 0 0 0-1.15 1.15v14.21a1.14 1.14 0 0 0 1.15 1.15h21.94a1.14 1.14 0 0 0 1.14-1.15V30.21a1.14 1.14 0 0 0-1.14-1.15z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1 43.53h-.9a6.2 6.2 0 0 1-4.37-10.61 6.14 6.14 0 0 1 4.37-1.81h.9a1 1 0 0 1 1 1v10.42a1 1 0 0 1-1 1zm-1-10.42a4.12 4.12 0 0 0-2.86 1.23 4.19 4.19 0 0 0 2.86 7.18zM35.23 43.53h-.9a1 1 0 0 1-1-1V32.11a1 1 0 0 1 1-1h.9a6.21 6.21 0 0 1 0 12.42zm.1-10.42v8.41a4.21 4.21 0 0 0 0-8.41zM14.79 38.45a3.2 3.2 0 1 1 3.21-3.2 3.2 3.2 0 0 1-3.21 3.2zm0-4.39a1.2 1.2 0 0 0 0 2.39 1.2 1.2 0 0 0 0-2.39zM27.64 38.45a3.2 3.2 0 1 1 3.2-3.2 3.2 3.2 0 0 1-3.2 3.2zm0-4.39a1.2 1.2 0 0 0 0 2.39 1.2 1.2 0 1 0 0-2.39zM24.79 42.58h-7.15a1 1 0 0 1 0-2h7.15a1 1 0 1 1 0 2zM27.25 29.06a1 1 0 0 1-1-1 5 5 0 0 0-10.06 0 1 1 0 0 1-2 0 7 7 0 0 1 14.06 0 1 1 0 0 1-1 1z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.22 23a1 1 0 0 1-1-1v-5.35a1 1 0 0 1 2 0V22a1 1 0 0 1-1 1z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.22 17.66a3.21 3.21 0 1 1 3.19-3.22 3.21 3.21 0 0 1-3.19 3.22zm0-4.42a1.21 1.21 0 1 0 1.19 1.2 1.2 1.2 0 0 0-1.19-1.2zM25.62 52.86h-8.81a1 1 0 0 1-1-1v-5.29a1 1 0 0 1 1-1h8.81a1 1 0 0 1 1 1v5.29a1 1 0 0 1-1 1zm-7.81-2h6.81v-3.29h-6.81z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.16 67H6.27a1 1 0 0 1-1-1V55.69a4.84 4.84 0 0 1 4.84-4.83h22.22a4.84 4.84 0 0 1 4.83 4.83V66a1 1 0 0 1-1 1zM7.27 65h27.89v-9.31a2.83 2.83 0 0 0-2.83-2.83H10.11a2.84 2.84 0 0 0-2.84 2.83z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.26 67H12.17a1 1 0 0 1-1-1v-7.42a1 1 0 0 1 1-1h18.09a1 1 0 0 1 1 1V66a1 1 0 0 1-1 1zm-17.09-2h16.09v-5.42H13.17zM38.29 29.3a1 1 0 0 1-1-1v-4.49a3.21 3.21 0 0 1-3.2-3.2V4.19A3.21 3.21 0 0 1 37.25 1h26.56A3.21 3.21 0 0 1 67 4.19v16.42a3.21 3.21 0 0 1-3.2 3.2H51l-12.3 5.41a1.1 1.1 0 0 1-.41.08zM37.25 3a1.19 1.19 0 0 0-1.2 1.2v16.41a1.19 1.19 0 0 0 1.2 1.2h1a1 1 0 0 1 1 1v4l11.13-4.91a.9.9 0 0 1 .4-.09h13a1.19 1.19 0 0 0 1.2-1.2V4.19A1.19 1.19 0 0 0 63.81 3z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 13.4H40a1 1 0 0 1 0-2h21a1 1 0 0 1 0 2zM55.76 17.67H45.29a1 1 0 1 1 0-2h10.47a1 1 0 0 1 0 2zM55.76 9.13H45.29a1 1 0 1 1 0-2h10.47a1 1 0 0 1 0 2z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistant);
export default __webpack_public_path__ + "static/media/AiAssistant.12121c791a72791805ba10c6f43987ea.svg";
export { ForwardRef as ReactComponent };